export const pageRoutes = {
  REFI_NOT_ACCEPTED: "/refinance/not-accepted",
  INSCHOOL_NEW_APPLICATION: "/applications/new",
  INSCHOOL_REVIEWS: "/reviews",
  INSCHOOL_DASHBOARD: "/applications",
  HELP_CENTER: "/help-center",
  REFERRAL: "/referral",
};
